import { FaFileImage, FaFileWord, FaFilePdf, FaFileExcel, FaFile, FaFileArchive } from 'react-icons/fa';

interface IProps {
    extension: string
}

let FileIcon = ({ extension }: IProps) => {

    switch (extension) {
        case ".png":
        case ".jpg":
        case ".jpeg":
            return (<FaFileImage />);

        case ".doc":
        case ".docx":
            return (<FaFileWord />);

        case ".xls":
        case ".xlsx":
            return (<FaFileExcel />);

        case ".pdf":
            return (<FaFilePdf />);

        case ".zip":
        case ".7z":
        case ".rar":
            return (<FaFileArchive />)

        default:
            return (<FaFile />)
    }
}

export default FileIcon;